import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable} from 'rxjs'
import { environment } from '../../../../environments/environment'
import { ChantierDto } from './dto/chantier.dto'
import { PatchChantierDto } from './dto/patch-chantier.dto'


@Injectable({ providedIn: 'root' })
export class ChantierHttp {
  private static readonly endpoint = environment.baseUrl + '/chantiers'
  private readonly http = inject(HttpClient)

  getChantierByCode(codeChantier: string): Observable<ChantierDto> {
    return this.http.get<ChantierDto>(`${ChantierHttp.endpoint}/${codeChantier}`
    )
  }

  patchChantier(codeChantier: string, body: PatchChantierDto): Observable<ChantierDto> {
    return this.http.patch<ChantierDto>(`${ChantierHttp.endpoint}/${codeChantier}`, body)
  }
}
